import clsx from 'clsx';
import React from 'react';

import usePowerlistHeader from '../../hooks/usePowerlistHeader';
import { article_path } from '../../routes';
import { IMGIX_URL } from '../../src/env';
import ProExclusiveLogo from '../shared/ProExclusiveLogo';
import styles from './styles.module.scss';

const desktopHeaderLogoUrl = `${IMGIX_URL}/global/projects/enterprise-power-list/header-desktop.png`;
const mobileHeaderLogoUrl = `${IMGIX_URL}/global/projects/enterprise-power-list/header-mobile.png`;

const PowerlistHeader = () => {
  const { powerlistHeader, isLoadingHeader } = usePowerlistHeader('enterprise');

  return (
    <>
      <div className="row image-container">
        <ProExclusiveLogo
          _class="tw-absolute w-8/10 md:w-7/10"
          mobileClass="top-24"
          tabletClass="top-32"
          desktopClass="top-32"
        />
        <div className="image-wrapper">
          <img
            srcSet={`${mobileHeaderLogoUrl} 1500w, ${desktopHeaderLogoUrl} 1860w`}
            src={mobileHeaderLogoUrl}
            height={637}
            width={1860}
            alt="top banner image"
          />
        </div>
      </div>
      {!isLoadingHeader && (
        <div className={clsx(styles.introContainer, 'row intro-container')}>
          <div className="row">
            <div className="col-sm-8 col-sm-offset-2 col-xs-10 col-xs-offset-1 intro-text-container">
              <div className={clsx(styles.introByline, 'power-byline')}>
                {powerlistHeader.byline}
              </div>
              <div className="power-description">
                {powerlistHeader.description}{' '}
                {powerlistHeader.articleSlug && (
                  <span>
                    Read the{' '}
                    <a
                      className={styles.articleLink}
                      href={article_path(powerlistHeader.articleSlug)}
                    >
                      related article
                    </a>{' '}
                    about the list and its criteria.
                  </span>
                )}
              </div>
            </div>
          </div>
          {powerlistHeader.articleSlug && (
            <div className="row">
              <div className="article-button">
                <a href={article_path(powerlistHeader.articleSlug)}>Read The Article</a>
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default PowerlistHeader;
